import type { JSX } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';
import { useDeactivateStudent } from '@/features/students/hooks';

/**
 * `DELETE /students/:id` (`deactivateStudent`) is a soft deactivation with
 * no reactivation endpoint in the current backend - the confirmation copy
 * says so accurately rather than implying a reversible or hard delete.
 */
export function DeactivateStudentButton({
  studentId,
}: {
  readonly studentId: string;
}): JSX.Element {
  const deactivate = useDeactivateStudent();
  const navigate = useNavigate();

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button type="button" variant="destructive" size="sm" disabled={deactivate.isPending}>
          Nonaktifkan Santri
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Nonaktifkan santri ini?</AlertDialogTitle>
          <AlertDialogDescription>
            Santri akan dinonaktifkan dan tidak lagi muncul dalam daftar santri aktif. Tindakan ini
            tidak dapat dibatalkan dari dalam aplikasi.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Batal</AlertDialogCancel>
          <AlertDialogAction
            disabled={deactivate.isPending}
            onClick={() => {
              deactivate.mutate(studentId, {
                onSuccess: () => {
                  void navigate('/students');
                },
              });
            }}
          >
            Nonaktifkan
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
